import React from 'react';
import ReactJson from 'react-json-view';

import CollapsibleCardView from '../../common/CardView/CollapsibleCardView';
import EngineIcon from '../../common/icons/EngineIcon';
import ErrorLabel from '../../common/Labels/ErrorLabel';
import Icon from '../../common/icons/Icon';

import { getThemeColor } from '../../../utils/theme-utils';

export const PipelineEngineConfigView = ({ engineConfig }) => (
  <CollapsibleCardView headerText="Engine Configuration" icon={EngineIcon}>
    {
      engineConfig ? (
        <div className="border border-border-dark rounded mt-2 py-2 px-4 overflow-y-scroll">
          <ReactJson
            src={engineConfig}
            indentWidth={2}
            name={false}
            displayDataTypes={false}
            displayArrayKey
            quotesOnKeys
          />
        </div>
      ) : (
        <div className="p-4 flex-grow flex flex-col justify-center items-center">
          <Icon
            fill={getThemeColor('brand')}
            icon={EngineIcon}
            size={64}
            useTailwindSizing
          />
          <ErrorLabel>Could not load engine configuration</ErrorLabel>
        </div>
      )
    }
  </CollapsibleCardView>
)

export default PipelineEngineConfigView;
